<template>
  <div>
    <canvas v-bind:id="this.id"></canvas>
  </div>
</template>
<script>

import Chart from 'chart.js';

export default {
  name: "QALYChart",
  props: ['id'],
  data () {
    return {
			chart: null
    }
  },
  computed: {
    barChartData () {
      return {
        type: 'horizontalBar',
        data: {
            labels: ["DX", "PLB"],
            datasets: [{
                data: [this.model.QALY[0], this.model.QALY[1]],
                backgroundColor: ['rgba(209,230,245,1.0)','rgba(216,234,247,0.7)']
            }]
        },
        options: {
            hover:false,
            title: {
                display: false
            },
            legend: {
                display: false
            },
            scales: {
                xAxes:[{
                    gridLines: {
                        display: false
                    },
                    ticks: {
                        beginAtZero:true
                    },
                    position:'top'
                }],
                yAxes: [{
                    gridLines: {
                        display: false
                    },
                    ticks: {
                        beginAtZero:true
                    }
                }]
            },
            tooltips: {
                enabled: false
            },
            animation:{
                duration:10.0,
                easing:'easeInSine'
            }
        }
      }
    },
    model() {
      return this.$store.getters.getCEAModel.model;
    },
    QALYValue() {
     return this.model.QALY[0];
    },
    costValue() {
     return this.model.totalCosts[0];
    },
    model2() {
      return this.$store.getters.getCEAModel;
    }
  },
  mounted () {
    this.chart = this.createChart('bar-chart', this.barChartData);
  },
  methods: {
    updateCharts() {
      this.chart.data = this.barChartData.data;
      this.chart.update();
    },
    createChart(chartId, barChartData) {
      const ctx = document.getElementById(this.id);
      const myChart = new Chart(ctx, {
        type: barChartData.type,
        data: barChartData.data,
        options: barChartData.options,
        });

      return myChart;
    },
    getUpdatedCostChartData(exclude) {
      var data1 = {
          label: this.model2.cost.directCost[5][0],
          data:[this.model.otherDrugs[0],this.model.otherDrugs[1]],
          backgroundColor:'rgba(159,202,233,1.0)',
          borderWidth: 0
      };
      var data2 = {
          label:this.model2.cost.directCost[3][0],
          data:[this.model.hospitalization[0],this.model.hospitalization[1]],
          backgroundColor:'rgba(159,202,233,0.78)',
          borderWidth: 0
      };
      var data3 = {
          label:this.model2.cost.directCost[4][0],
          data: [this.model.antidepressant[0],this.model.antidepressant[1]],
          backgroundColor:'rgba(159,202,233,0.65)',
          borderWidth: 0
      };
      var data4 = {
          label:this.model2.uiLabels.treatment,
          data: [this.model.dx[0],this.model.dx[1]],
          backgroundColor: 'rgba(39,52,120,1.0)',
          borderWidth: 0
      };
      var data5 = {
          label:this.model2.cost.directCost[2][0],
          data:[this.model.other[0],this.model.other[1]],
          backgroundColor:'rgba(159,202,233,0.45)',
          borderWidth: 0
      };
      var data6 = {
          label: this.model2.cost.directCost[1][0],
          data: [this.model.outpatient[0],this.model.outpatient[1]],
          backgroundColor:'rgba(159,202,233,0.3)',
          borderWidth: 0
      };
      var data7 = {
          label:'Sick leave',
          data:[this.model.leave[0],this.model.leave[1]],
          backgroundColor:'rgba(159,202,233,0.2)',
          borderWidth: 0
      };
      if(exclude){
          return [data7,data6,data5,data4,data3,data2,data1];
      } else {
          return [data6,data5,data4,data3,data2,data1];
      }
    }
  },
  watch: {
    QALYValue() {
        this.updateCharts();
    }, 
    costValue() {
        this.updateCharts();
    }
  }
}
</script>

<style lang="scss">
@import "../scss/bootstrap-custom.scss";
@import "../../node_modules/bootstrap/scss/bootstrap.scss";
</style>


// WEBPACK FOOTER //
// src/components/QALYChart.vue